module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1ASlmUR/media/FC-9781035801930.jpg?1695340671798",
      "alt": "This image is the cover for the book The Creator"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Creator\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Discover the epic tale of Draconian, the first being in existence, in the gripping novel The Creator. Witness as he creates Alaskia, a vast universe filled with billions of planets and countless species, which he rules as King and Emperor. With his vast power, he creates civilizations, gives life to beings and shapes entire worlds. However, as time passes, a threat arises that Draconian could never have foreseen. Envy and treachery begin to spread, threatening to tear his universe apart and putting the existence of every citizen in jeopardy. As the danger grows, Draconian must face a difficult choice: to fight and protect his creation, or to watch it all crumble before him.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Priya Grewal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Priya Grewal is from Hounslow, West London, UK. She graduated from University College London with a 2.1 in BA History in 2011. Priya currently lives in Uxbridge, West London and loves reading, watching films and has a passion for writing.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0